<template>
  <div class="container mt-5 text-center">
    Merci de vous connecter à votre compte Salesforce pour utiliser cette application
    <b-img :src="require('./../assets/globe_animated.gif')" fluid style="height: 80px"></b-img>
  </div>
</template>

<script>

  export default {
    name: 'SalesforceLogin'
  }
</script>

<style scoped>

</style>